import { Column, Entity, Index, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { Utils } from '../service/utils.service';
import { IBuilding } from './interface/IBuilding';
import { IInstallation } from './interface/IInstallation';
import { IVerification } from './interface/IVerification';
import { ILevel } from './interface/ILevel';
import { IObservation } from './interface/IObservation';

@Entity('building')
export class Building extends BaseEntity implements IBuilding{
  apiMapping = {
    id: 'extId',
    localId: 'id',
    isDeleted: 'isDeleted',
    isNew: 'isNew',
    name: 'name',
    order: 'position',
    levels: {
      fieldName: 'levels',
      type: 'Level',
      map: true,
      mapType: 'many'
    },
    installations: {
      fieldName: 'installations',
      type: 'Installation',
      map: true,
      mapType: 'many'
    },
    observations: {
      type: 'Observation',
      fieldName: 'observations',
      map: true,
      mapType: 'many',
    }
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column({ nullable: true })
  @Index()
  extId: number;

  @Column({ nullable: true })
  name: string;

  @Column({ nullable: true })
  nameSearch: string;

  @Column({ nullable: true })
  isDeleted: boolean;

  @Column({ nullable: true })
  isNew: boolean;

  @Column({ nullable: true })
  position: number;

  cannotModify: boolean;

  @ManyToOne('Verification', 'buildings')
  @JoinColumn()
  verification: IVerification;

  @OneToMany('Level', 'building', { cascade: true })
  levels: ILevel[];

  @OneToMany('Observation', 'building', { cascade: true })
  observations: IObservation[];

  @OneToMany('Installation', 'building', { cascade: true })
  installations: IInstallation[];

  async fromApi(data: any, update = false) {
    await super.fromApi(data, update);
    this.nameSearch = Utils.removeAccents(this.name);
    return this;
  }
}
